import { SEARCH_TRIGGER_DATA_ATTRIBUTE } from 'components/tasks/constants';
import { getNodesFromHtml } from 'helpers/dom';
import { Bookmark, EditorSelection } from 'tinymce';

const isSearchTrigger = (element: HTMLElement) => {
    return element.dataset.hasOwnProperty('gbSearchTrigger');
};

const isLinkNode = (element: HTMLElement) => {
    return element.dataset.hasOwnProperty('gbTaskLink');
};

const removeTrigger = (selection: EditorSelection, bookmark: Bookmark) => {
    const currentNode = selection.getNode();

    if (isSearchTrigger(currentNode)) {
        currentNode.remove();
    }

    selection.moveToBookmark(bookmark);
};

const hasLinkSearchNodes = (description: string) => {
    const triggerNodes = getNodesFromHtml({
        html: description,
        selectors: `span[${SEARCH_TRIGGER_DATA_ATTRIBUTE}]`,
    });

    if (triggerNodes.length > 0) return true;

    for (const node of Array.from(getNodesFromHtml({ html: description, selectors: '*' }))) {
        if (node.textContent?.includes(' @')) {
            return true;
        }
    }

    return false;
};

export { isSearchTrigger, isLinkNode, removeTrigger, hasLinkSearchNodes };
